import get from "lodash.get";

export default mapping => ({
  methods: {
    // Note: fieldName (returned from backend) and field's ref (used in frontend's form) must be exact!
    handleValidationError({ response }) {
      if (get(response, "data.code") === "VALIDATION_ERROR") {
        Object.entries(mapping).forEach(([key, message]) => {
          const [fieldName, code] = key.split(":");
          const errors = [];

          if (
            response.data.payload[fieldName] &&
            response.data.payload[fieldName].includes(code)
          ) {
            errors.push(message);
          }

          this.$refs[fieldName].setErrors(errors);
        });
      }
    }
  }
});
